import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { MdWarning as WarningIcon } from 'react-icons/md';

import { debouncedRebuildReactTooltip } from '../../debouncedRebuildReactTooltip';


const DiagnosticsSeverityCellRenderer = ({ value, data, tooltipContentField = null }) => {
  useEffect(() => {
    if (tooltipContentField) {
      debouncedRebuildReactTooltip();
    }
  }, [value, data, tooltipContentField]);

  return (
    value
      ? (
        <WarningIcon
          size={18}
          className={classnames({
            'diagnostics-severity-warning': value === '1',
            'diagnostics-severity-fatal': value === '-1',
          })}
          // eslint-disable-next-line no-undefined
          data-tip={tooltipContentField ? data[tooltipContentField] : undefined}
        />
      )
      : null
  );
};

DiagnosticsSeverityCellRenderer.propTypes = {
  value: PropTypes.string,
  tooltipContentField: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
};

export default DiagnosticsSeverityCellRenderer;
